import React from "react";
import { create } from "mobx-persist";
import { UIStore } from "./UIStore";
import { NavigationStore } from "src/stores/NavigationStore";
import { EasyContactStore } from "./EasyContactStore";
import { AuthStore } from "./AuthStore";

export const hydrate = create({
    storage: localStorage,
    jsonify: true
});

export class RootStore {
    uiStore = new UIStore(this);
    navStore = new NavigationStore(this);
    authStore = new AuthStore(this);
    easyContactStore = new EasyContactStore(this);
    constructor() {
        hydrate("@easycontact", this.authStore).finally(() => this.authStore.setLoaded(true));
        hydrate("@easyContactStore", this.easyContactStore);
    }
}

export const RootStoreContext = React.createContext<RootStore>(undefined!);
